import { render } from "./LoginBlackCentered.vue?vue&type=template&id=c63c7af2"
import script from "./LoginBlackCentered.vue?vue&type=script&lang=js"
export * from "./LoginBlackCentered.vue?vue&type=script&lang=js"

import "./LoginBlackCentered.vue?vue&type=style&index=0&id=c63c7af2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__